import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface IAppVariablesFilterProps {
  formik: FormikProps<any>;
  filterTypeOptions: Array<{ id: string; name: string }>;
  filterIsPrivateOptions: Array<{ id: string | boolean; name: string }>;
}

export function AppVariablesFilter(props: IAppVariablesFilterProps) {
  const { formik, filterTypeOptions, filterIsPrivateOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.type')}
          name="type"
          options={filterTypeOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.private')}
          name="isPrivate"
          options={filterIsPrivateOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
